module.exports = __webpack_public_path__ + "static/media/tails.661bfe9d.png";